module.exports = new __parcel__URL__("shark.af44e0c5.svg").toString();